import { AccountRecord, AccountState } from './account.state';
import * as actions from './account.action';
import { RegisterUserModel, UserModel } from './models/registerUser.model';
import { LoginUserModel } from './models/loginUser.model';
import { CortizoUserModel } from './models/user.model';

export const initialState: AccountState = (new AccountRecord() as unknown) as AccountState;

export function reducer(state = initialState, { type, payload }: any): AccountState {
    if (!type) {
        return state;
    }
    switch (type) {
        case actions.ActionTypes.REGISTER_USER: {
            return Object.assign({}, state, {
                registerUserLoading: true,
                registerUserLoaded: false,
                registerUserFail: false,
                registerUserData: null,
                registerUserErrors: null,
            });
        }
        case actions.ActionTypes.REGISTER_USER_SUCCESS: {
            let errMessage = null;
            let registeredUser = null;
            if (payload && payload.isError) {
                errMessage = payload.message || '';
            } else if (payload) {
                registeredUser = new RegisterUserModel(payload);
            }

            return Object.assign({}, state, {
                registerUserLoading: false,
                registerUserLoaded: true,
                registerUserFail: false,
                registerUserData: registeredUser,
                registerUserErrors: errMessage,
            });
        }
        case actions.ActionTypes.REGISTER_USER_FAIL: {
            return Object.assign({}, state, {
                registerUserLoading: false,
                registerUserLaded: false,
                registerUserFail: true,
                registerUserData: null,
                registerUserErrors: null,
            });
        }
        case actions.ActionTypes.CLEAR_REGISTER_STATE: {
            return Object.assign({}, state, {
                registerUserLoading: false,
                registerUserLaded: false,
                registerUserFail: false,
                registerUserData: null,
                registerUserErrors: null,
            });
        }

        case actions.ActionTypes.LOGIN_USER: {
            return Object.assign({}, state, {
                loginUserLoading: true,
                loginUserLoaded: false,
                loginUserFail: false,
                loginUserData: null,
                loginUserErrors: null,
                currentUserToken: null,
                currentUserRole: null,
            });
        }
        case actions.ActionTypes.LOGIN_USER_SUCCESS: {
            let errMessage = null;
            let loginedUser = null;

            if (payload && payload.IsError) {
                errMessage = payload.message || '';
            } else if (payload && payload.data) {
                loginedUser = new LoginUserModel(payload.data);
            }
            if (!payload?.success && payload?.message) {
                errMessage = payload.message;
            }

            return Object.assign({}, state, {
                loginUserLoading: false,
                loginUserLoaded: true,
                loginUserFail: false,
                loginUserData: loginedUser,
                loginUserErrors: errMessage,
                lastLoginedUserInfo: loginedUser,
                currentUserToken: loginedUser ? loginedUser.token : '',
                currentUserRole: loginedUser ? loginedUser.role : ''
            });
        }
        case actions.ActionTypes.LOGIN_USER_FAIL: {
            return Object.assign({}, state, {
                loginUserLoading: false,
                loginUserLoaded: false,
                loginUserFail: true,
                loginUserData: null,
                loginUserErrors: null,
                currentUserToken: null,
                currentUserRole: null,
            });
        }
        case actions.ActionTypes.CLEAR_LOGIN_STATE: {
            return Object.assign({}, state, {
                loginUserLoading: false,
                loginUserLoaded: false,
                loginUserFail: false,
                loginUserData: null,
                loginUserErrors: null
            });
        }

        case actions.ActionTypes.SEND_PASSWORD_RECOVERY_KEY: {
            return Object.assign({}, state, {
                sendPasswordRecoveryKeyLoading: true,
                sendPasswordRecoveryKeyLoaded: false,
                sendPasswordRecoveryKeyFail: false,
                sendPasswordRecoveryKeyData: null,
                sendPasswordRecoveryKeyErrMessage: null,
            });
        }
        case actions.ActionTypes.SEND_PASSWORD_RECOVERY_KEY_SUCCESS: {
            const err = !payload.success;
            const errMes = err && payload.message ? payload.message : null;

            return Object.assign({}, state, {
                sendPasswordRecoveryKeyLoading: false,
                sendPasswordRecoveryKeyLoaded: true,
                sendPasswordRecoveryKeyFail: false,
                sendPasswordRecoveryKeyData: !err ? payload : null,
                sendPasswordRecoveryKeyErrMessage: errMes,
            });
        }
        case actions.ActionTypes.SEND_PASSWORD_RECOVERY_KEY_FAIL: {
            return Object.assign({}, state, {
                sendPasswordRecoveryKeyLoading: false,
                sendPasswordRecoveryKeyLoaded: false,
                sendPasswordRecoveryKeyFail: true,
                sendPasswordRecoveryKeyData: null,
                sendPasswordRecoveryKeyErrMessage: null,
            });
        }
        case actions.ActionTypes.CLEAR_SEND_PASSWORD_RECOVERY_KEY_STATE: {
            return Object.assign({}, state, {
                sendPasswordRecoveryKeyLoading: false,
                sendPasswordRecoveryKeyLoaded: false,
                sendPasswordRecoveryKeyFail: false,
                sendPasswordRecoveryKeyData: null,
                sendPasswordRecoveryKeyErrMessage: null,
            });
        }

        case actions.ActionTypes.CHANGE_PASSWORD: {
            return Object.assign({}, state, {
                changePasswordLoading: true,
                changePasswordLoaded: false,
                changePasswordFail: false,
                changePasswordData: null,
                changePasswordErrMessage: null,
            });
        }
        case actions.ActionTypes.CHANGE_PASSWORD_SUCCESS: {
            const err = !payload.success;
            const errMes = err && payload.message ? payload.message : null;

            return Object.assign({}, state, {
                changePasswordLoading: false,
                changePasswordLoaded: true,
                changePasswordFail: false,
                changePasswordData: !err ? payload : null,
                changePasswordErrMessage: errMes,
            });
        }
        case actions.ActionTypes.CHANGE_PASSWORD_FAIL: {
            return Object.assign({}, state, {
                changePasswordLoading: false,
                changePasswordLoaded: false,
                changePasswordFail: true,
                changePasswordData: null,
                changePasswordErrMessage: null,
            });
        }
        case actions.ActionTypes.CLEAR_CHANGE_PASSWORD_STATE: {
            return Object.assign({}, state, {
                changePasswordLoading: false,
                changePasswordLoaded: false,
                changePasswordFail: false,
                changePasswordData: null,
                changePasswordErrMessage: null,
            });
        }

        case actions.ActionTypes.DO_LOGOUT: {
            return Object.assign({}, state, {
                doLogOutEmitted: true,
                currentUserToken: null,
                currentUserRole: null,
            });
        }
        case actions.ActionTypes.DO_LOGOUT_SUCCESS: {
            return Object.assign({}, state, {
                doLogOutEmitted: false
            });
        }

        case actions.ActionTypes.GET_CURRENT_USER: {
            return Object.assign({}, state, {
                getCurrentUserLoading: true,
                getCurrentUserLoaded: false,
                getCurrentUserFail: false,
                getCurrentUserData: null,
            });
        }
        case actions.ActionTypes.GET_CURRENT_USER_SUCCESS: {
            let userInfo: UserModel = null;
            if (payload && payload.data && payload.success) {
                userInfo = new UserModel(payload.data);
            }

            return Object.assign({}, state, {
                getCurrentUserLoading: false,
                getCurrentUserLoaded: true,
                getCurrentUserFail: false,
                getCurrentUserData: userInfo ? userInfo : null,
                currentUserRole: userInfo ? userInfo.role : null,
            });
        }
        case actions.ActionTypes.GET_CURRENT_USER_FAIL: {
            return Object.assign({}, state, {
                getCurrentUserLoading: false,
                getCurrentUserLoaded: false,
                getCurrentUserFail: true,
                getCurrentUserData: null,
            });
        }
        case actions.ActionTypes.CLEAR_GET_CURRENT_USER_STATE: {
            return Object.assign({}, state, {
                getCurrentUserLoading: false,
                getCurrentUserLoaded: false,
                getCurrentUserFail: false,
                getCurrentUserData: null,
            });
        }

        case actions.ActionTypes.GET_USERS_LIST: {
            return Object.assign({}, state, {
                getUsersListLoading: true,
                getUsersListData: null,
                getUsersListDataAmount: 0,
                getUsersListFailData: null
            });
        }
        case actions.ActionTypes.GET_USERS_LIST_SUCCESS: {
            let data = null;
            let amount = null;
            let err = null;
            if (payload.data && payload.data.users && !!payload.data.users.length) {
                data = payload.data.users.map((el: any) => new CortizoUserModel(el));
                amount = payload.data && payload.data.amount ? payload.data.amount : 0;
            } else {
                err = payload;
            }

            return Object.assign({}, state, {
                getUsersListLoading: false,
                getUsersListData: data,
                getUsersListDataAmount: amount,
                getUsersListFailData: err
            });
        }
        case actions.ActionTypes.GET_USERS_LIST_FAIL: {
            return Object.assign({}, state, {
                getUsersListLoading: false,
                getUsersListData: null,
                getUsersListDataAmount: 0,
                getUsersListFailData: payload
            });
        }
        case actions.ActionTypes.CLEAR_GET_USERS_LIST_STATE: {
            return Object.assign({}, state, {
                getUsersListLoading: false,
                getUsersListData: null,
                getUsersListDataAmount: 0,
                getUsersListFailData: null
            });
        }

        case actions.ActionTypes.UPDATE_USER_ITEM: {
            return Object.assign({}, state, {
                updateUserItemLoading: true,
                updateUserItemData: null,
                updateUserItemFailData: null,
            })
        }
        case actions.ActionTypes.UPDATE_USER_ITEM_SUCCESS: {
            let data = null;
            let err = null;
            if (payload.data && payload.success) {
                data = payload.data
            } else {
                err = payload;
            }
            return Object.assign({}, state, {
                updateUserItemLoading: false,
                updateUserItemData: data,
                updateUserItemFailData: err,
            })
        }
        case actions.ActionTypes.UPDATE_USER_ITEM_FAIL: {
            return Object.assign({}, state, {
                updateUserItemLoading: false,
                updateUserItemData: null,
                updateUserItemFailData: payload,
            })
        }
        case actions.ActionTypes.CLEAR_UPDATE_USER_ITEM_STATE: {
            return Object.assign({}, state, {
                updateUserItemLoading: false,
                updateUserItemData: null,
                updateUserItemFailData: null,
            })
        }

        case actions.ActionTypes.IMPORT_USERS_FROM_FILE: {
            return Object.assign({}, state, {
                importUsersFromFileLoading: true,
                importUsersFromFileData: null,
                importUsersFromFileFailData: null,
            })
        }
        case actions.ActionTypes.IMPORT_USERS_FROM_FILE_SUCCESS: {
            let data = null;
            let err = null;
            if (payload.data && payload.success) {
                data = payload.data
            } else {
                err = payload;
            }
            return Object.assign({}, state, {
                importUsersFromFileLoading: false,
                importUsersFromFileData: data,
                importUsersFromFileFailData: err,
            })
        }
        case actions.ActionTypes.IMPORT_USERS_FROM_FILE_FAIL: {
            return Object.assign({}, state, {
                importUsersFromFileLoading: false,
                importUsersFromFileData: null,
                importUsersFromFileFailData: payload,
            })
        }
        case actions.ActionTypes.CLEAR_IMPORT_USERS_FROM_FILE_STATE: {
            return Object.assign({}, state, {
                importUsersFromFileLoading: false,
                importUsersFromFileData: null,
                importUsersFromFileFailData: null,
            })
        }
        case actions.ActionTypes.UPDATE_USER_ROLE: {
          return {
              ...state,
              updateUserRoleData: null,
              updateUserRoleFailData: null,
          };
      }
      case actions.ActionTypes.UPDATE_USER_ROLE_SUCCESS: {
          return {
              ...state,
              updateUserRoleData: payload,
              updateUserRoleFailData: null,
          };
      }
      case actions.ActionTypes.UPDATE_USER_ROLE_FAIL: {
          return {
              ...state,
              updateUserRoleData: null,
              updateUserRoleFailData: payload,
          };
      }
      case actions.ActionTypes.CLEAR_UPDATE_USER_ROLE_STATE: {
        return {
          ...state,
          updateUserRoleData: null,
          updateUserRoleFailData: null,
        };
      }
      // Add the case to remove rol
      case actions.ActionTypes.REMOVE_USER_ROLE_SUCCESS: {
          return {
              ...state,
              updateUserRoleData: payload,
              updateUserRoleFailData: null,
          };
      }
      case actions.ActionTypes.REMOVE_USER_ROLE_FAIL: {
          return {
              ...state,
              updateUserRoleData: null,
              updateUserRoleFailData: payload,
          };
      }

        default: {
            return state;
        }
    }
}

export const registerUserLoading = (state: AccountState) => state.registerUserLoading;
export const registerUserLoaded = (state: AccountState) => state.registerUserLoaded;
export const registerUserFail = (state: AccountState) => state.registerUserFail;
export const registerUserData = (state: AccountState) => state.registerUserData;
export const registerUserErrors = (state: AccountState) => state.registerUserErrors;

export const loginUserLoading = (state: AccountState) => state.loginUserLoading;
export const loginUserLoaded = (state: AccountState) => state.loginUserLoaded;
export const loginUserFail = (state: AccountState) => state.loginUserFail;
export const loginUserData = (state: AccountState) => state.loginUserData;
export const loginUserErrors = (state: AccountState) => state.loginUserErrors;

export const sendPasswordRecoveryKeyLoading = (state: AccountState) => state.sendPasswordRecoveryKeyLoading;
export const sendPasswordRecoveryKeyLoaded = (state: AccountState) => state.sendPasswordRecoveryKeyLoaded;
export const sendPasswordRecoveryKeyFail = (state: AccountState) => state.sendPasswordRecoveryKeyFail;
export const sendPasswordRecoveryKeyData = (state: AccountState) => state.sendPasswordRecoveryKeyData;
export const sendPasswordRecoveryKeyErrMessage = (state: AccountState) => state.sendPasswordRecoveryKeyErrMessage;

export const changePasswordLoading = (state: AccountState) => state.changePasswordLoading;
export const changePasswordLoaded = (state: AccountState) => state.changePasswordLoaded;
export const changePasswordFail = (state: AccountState) => state.changePasswordFail;
export const changePasswordData = (state: AccountState) => state.changePasswordData;
export const changePasswordErrMessage = (state: AccountState) => state.changePasswordErrMessage;

export const lastLoginedUserInfo = (state: AccountState) => state.lastLoginedUserInfo;
export const currentUserToken = (state: AccountState) => state.currentUserToken;
export const currentUserRole = (state: AccountState) => state.currentUserRole;

export const doLogOutEmitted = (state: AccountState) => state.doLogOutEmitted;

export const getCurrentUserLoading = (state: AccountState) => state.getCurrentUserLoading;
export const getCurrentUserLoaded = (state: AccountState) => state.getCurrentUserLoaded;
export const getCurrentUserFail = (state: AccountState) => state.getCurrentUserFail;
export const getCurrentUserData = (state: AccountState) => state.getCurrentUserData;

export const getUsersListLoading = (state: AccountState) => state.getUsersListLoading;
export const getUsersListData = (state: AccountState) => state.getUsersListData;
export const getUsersListDataAmount = (state: AccountState) => state.getUsersListDataAmount;
export const getUsersListFailData = (state: AccountState) => state.getUsersListFailData;

export const updateUserItemLoading = (state: AccountState) => state.updateUserItemLoading;
export const updateUserItemData = (state: AccountState) => state.updateUserItemData;
export const updateUserItemFailData = (state: AccountState) => state.updateUserItemFailData;

export const importUsersFromFileLoading = (state: AccountState) => state.importUsersFromFileLoading;
export const importUsersFromFileData = (state: AccountState) => state.importUsersFromFileData;
export const importUsersFromFileFailData = (state: AccountState) => state.importUsersFromFileFailData;

export const updateUserRoleData = (state: AccountState) => state.updateUserRoleData;
export const updateUserRoleFailData = (state: AccountState) => state.updateUserRoleFailData;
